'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _imagePanel = require('../../../molecules/image-panel');

var _imagePanel2 = _interopRequireDefault(_imagePanel);

var _panels = require('../../panels');

var _panels2 = _interopRequireDefault(_panels);

var _default = require('../props/default');

var _default2 = _interopRequireDefault(_default);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var DevicePanels = function (_Panels) {
  _inherits(DevicePanels, _Panels);

  function DevicePanels() {
    _classCallCheck(this, DevicePanels);

    return _possibleConstructorReturn(this, (DevicePanels.__proto__ || Object.getPrototypeOf(DevicePanels)).apply(this, arguments));
  }

  _createClass(DevicePanels, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          className = _props.className,
          content = _props.content,
          config = _props.config;
      var items = content.items;
      var id = config.id,
          deviceImage = config.deviceImage,
          backgroundImage = config.backgroundImage;
      var deviceImagePosition = config.deviceImagePosition,
          theme = config.theme;


      deviceImagePosition = deviceImagePosition || 'right';
      theme = theme || 'theme-background-color-blue-alt';

      var deviceImageStyle = {
        backgroundImage: 'url(' + deviceImage + ')',
        backgroundPosition: '' + (deviceImagePosition === 'right' ? 'right center' : 'left center')
      };

      var backgroundImageStyle = {
        backgroundImage: 'url(' + backgroundImage + ')'
      };

      var panelsClasses = (0, _classnames2.default)(theme, className, 'device-panels', 'panels');
      var children = this.renderDefaultChildren(items);

      return _react2.default.createElement(
        'section',
        {
          id: id,
          className: panelsClasses,
          'data-building-block': 'organism'
        },
        _react2.default.createElement(
          'div',
          { className: 'background-layer' },
          _react2.default.createElement('div', { className: 'col-lg-6 col-md-6 col-sm-12 col-xs-12 background-image ' + deviceImagePosition, style: backgroundImageStyle }),
          _react2.default.createElement('div', { className: 'col-lg-6 col-md-6 col-sm-12 col-xs-12 device-image', style: deviceImageStyle })
        ),
        _react2.default.createElement(
          'div',
          { className: 'container' },
          _react2.default.createElement(
            'div',
            { className: 'panels__container' },
            this.renderPanels(children)
          )
        )
      );
    }
  }]);

  return DevicePanels;
}(_panels2.default);

exports.default = DevicePanels;


DevicePanels.propTypes = _propTypes2.default.shape({
  config: _propTypes2.default.shape({
    id: _propTypes2.default.string,
    theme: _propTypes2.default.oneOf(['theme-background-color-dark', 'theme-background-color-blue-alt', 'theme-background-color-green', 'theme-background-color-pink', 'theme-background-color-purple']),
    deviceImage: _propTypes2.default.string.isRequired,
    backgroundImage: _propTypes2.default.string.isRequired,
    deviceImagePosition: _propTypes2.default.oneOf(['left', 'right']),
    columns: _propTypes2.default.oneOf([2]).isRequired
  }),
  className: _propTypes2.default.string,
  content: _propTypes2.default.shape({
    items: _propTypes2.default.arrayOf(_propTypes2.default.oneOfType([_propTypes2.default.shape(_imagePanel2.default.propTypes)]))
  })
});

DevicePanels.defaultProps = _default2.default;


//////////////////
// WEBPACK FOOTER
// /donatenodeweb-ci-2793/workspace/donate-gro-release/~/marketing-components/dist/components/organisms/device-panels/jsx/DevicePanels.js
// module id = 1079
// module chunks = 4